import React from 'react';

interface DashboardHeaderProps {
  counts: {
    activeOrders: number;
    awaitingResponse: number;
    needAttention: number;
    onTime: number;
    completed: number;
    cancelled: number;
  };
  onStatusClick: (status: string | null) => void;
}

const STATUS_ITEMS = [
  { key: 'activeOrders', label: 'Active Orders', className: 'bgnone', iconClass:null, icon: null },
  { key: 'awaitingResponse', label: 'Awaiting Response', className: 'warning', iconClass:null, icon: '../../awaiting.png' },
  { key: 'needAttention', label: 'Needs Attention', className: 'danger', iconClass:null, icon: '../../needsattantion2.png' },
  { key: 'onTime', label: 'On Time', className: 'bg-white-ontime', iconClass:null, icon: '../../completed.png' },
  { key: 'completed', label: 'Completed', className: 'success', icon: null, iconClass: 'bi bi-check-circle-fill completed-icon' },
  { key: 'cancelled', label: 'Cancelled', className: 'cancelled', icon: null, iconClass: 'bi bi-dash-circle-fill' },
] as const;

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ counts, onStatusClick }) => {
  return (
    <div className="container my-3 p-0">
      <div className="order-status-bar">
        {STATUS_ITEMS.map((item) => (
          <div
  key={item.key}
  className="status-item"
  style={{ cursor: "pointer" }}
  onClick={() => onStatusClick(item.label)}
>
            <div className="status-count">
              {counts[item.key as keyof typeof counts]}
            </div>
            <span className={`status-badge ${item.className}`}>
                             {item.icon ? (
        <img src={item.icon} alt="" className="status-icon" />
      ) : (
        item.iconClass && <i className={item.iconClass}></i>
      )}
              {item.label}
     
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};